<template>
	<div>
		<v-btn
			class="button"
			color="primary"
			outlined
			tile
			@click="isDialogOpen = true"
		>
			<p>Voir les coordonnées de contact</p>
		</v-btn>

		<DialogBox
			v-model="isDialogOpen"
			hide-actions
			title="Pour prendre rendez-vous"
			width="500px"
		>
			<section>
				<div
					v-for="contact in structureContactList"
					:key="contact.id"
				>
					<p
						v-if="contact.name"
					>
						{{ contact.name }}
					</p>
					<IconText
						v-if="contact.phone"
						:icon="mdiPhone"
						:text="contact.phone"
						icon-color="red"
					/>
					<IconText
						v-if="contact.email"
						:icon="mdiEmailOutline"
						:text="contact.email"
						icon-color="red"
					/>
					<IconText
						v-if="contact.website"
						:icon="mdiWeb"
						:text="contact.website"
						icon-color="red"
					/>
				</div>
			</section>
		</DialogBox>
	</div>
</template>

<script setup lang="ts">
	import { mdiEmailOutline, mdiPhone, mdiWeb } from '@mdi/js';
	import DialogBox from '@cnamts/vue-dot/src/elements/DialogBox';
	import { ref } from 'vue';

	import IconText from './icon-text.vue';
	import { ContactCard } from '@/types/contact-card';

	defineProps<{
		structureContactList: ContactCard[];
	}>();

	const isDialogOpen = ref(false);
</script>

<style lang="css" scoped>
p {
	margin: 0 !important;
}

.button {
	width: fit-content;
	padding: 5px;
	height: auto !important;
	max-width: 100%;
	white-space: normal;
}
</style>
